import "core-js/modules/es6.symbol.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import GlobalIntroWithParagraphs from '~/components/molecules/Editorial/Global/GlobalIntroWithParagraphs.vue';
import RegularTitle from '~/components/atoms/Global/RegularTitle.vue';
import SimpleParagraph from '~/components/atoms/Editorial/SimpleParagraph.vue';
import TextField from '~/components/atoms/TextField.vue';
import MdmSelect from '~/components/atoms/MdmSelect.vue';
import TextArea from '~/components/atoms/TextArea.vue';
import { validateEmail } from '~/helpers/validation-helper';
import submitProContactForm from '~/services/pro';
import MdmLoader from '~/components/atoms/Global/MdmLoader.vue';
var FieldType = {
  Text: 'text',
  number: 'number',
  Email: 'email',
  String: 'string'
};
export default {
  name: 'ContactForm',
  components: {
    GlobalIntroWithParagraphs,
    RegularTitle,
    SimpleParagraph,
    TextField,
    MdmSelect,
    TextArea,
    MdmLoader
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      form: {
        company: {
          label: this.$t('company'),
          model: null,
          error: null,
          type: FieldType.String,
          required: true
        },
        name: {
          label: this.$t('name'),
          model: null,
          error: null,
          type: FieldType.Text,
          required: true
        },
        email: {
          label: this.$t('email'),
          model: null,
          error: null,
          type: FieldType.Email,
          required: true
        },
        zipCode: {
          label: this.$t('zipcode'),
          model: null,
          error: null,
          type: FieldType.String,
          required: true
        },
        activity: {
          label: this.$t('activity.label'),
          model: null,
          error: null,
          type: FieldType.Text,
          required: true,
          options: [{
            id: 'hospitality',
            label: this.$t('activity.options.hospitality')
          }, {
            id: 'cafe_restaurants',
            label: this.$t('activity.options.cafe_restaurants')
          }, {
            id: 'property',
            label: this.$t('activity.options.property')
          }, {
            id: 'retail ',
            label: this.$t('activity.options.retail')
          }, {
            id: 'offices',
            label: this.$t('activity.options.offices')
          }, {
            id: 'public_body',
            label: this.$t('activity.options.public_body')
          }, {
            id: 'events_agency',
            label: this.$t('activity.options.events_agency')
          }, {
            id: 'press',
            label: this.$t('activity.options.press')
          }, {
            id: 'architects_decorators',
            label: this.$t('activity.options.architects_decorators')
          }]
        },
        country: {
          label: this.$t('country'),
          model: null,
          error: null,
          type: FieldType.Text,
          required: true,
          options: [{
            id: '6',
            name: this.$t('country_label_de')
          }, {
            id: '16',
            name: this.$t('country_label_ad')
          }, {
            id: '11',
            name: this.$t('country_label_at')
          }, {
            id: '2',
            name: this.$t('country_label_be')
          }, {
            id: '12',
            name: this.$t('country_label_dk')
          }, {
            id: '3',
            name: this.$t('country_label_es')
          }, {
            id: '1',
            name: this.$t('country_label_fr')
          }, {
            id: '13',
            name: this.$t('country_label_ie')
          }, {
            id: '4',
            name: this.$t('country_label_it')
          }, {
            id: '7',
            name: this.$t('country_label_lu')
          }, {
            id: '10',
            name: this.$t('country_label_nl')
          }, {
            id: '9',
            name: this.$t('country_label_pt')
          }, {
            id: '5',
            name: this.$t('country_label_gb')
          }, {
            id: '15',
            name: this.$t('country_label_si')
          }, {
            id: '14',
            name: this.$t('country_label_se')
          }, {
            id: '8',
            name: this.$t('country_label_ch')
          }]
        },
        requestType: {
          label: this.$t('requestype.label'),
          model: null,
          error: null,
          type: FieldType.Text,
          required: true,
          options: [{
            id: 'commercial_condition',
            label: this.$t('requestype.options.commercial_condition')
          }, {
            id: 'request_quote',
            label: this.$t('requestype.options.request_quote')
          }, {
            id: 'product_informations',
            label: this.$t('requestype.options.product_informations')
          }, {
            id: 'receive_catalog',
            label: this.$t('requestype.options.receive_catalog')
          }, {
            id: 'information_service_deco',
            label: this.$t('requestype.options.information_service_deco')
          }, {
            id: 'gift_card',
            label: this.$t('requestype.options.gift_card')
          }, {
            id: 'follow_order',
            label: this.$t('requestype.options.follow_order')
          }, {
            id: 'other',
            label: this.$t('requestype.options.other')
          }]
        },
        request: {
          label: this.$t('request'),
          model: null,
          error: null,
          type: FieldType.String,
          required: false
        }
      },
      submitStatus: null,
      showLoader: false
    };
  },

  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })), {}, {
    formPayload() {
      return {
        title: {
          text: this.payload.primary.formulaire_title[0].text || null,
          level: this.payload.primary.formulaire_title[0].type || null,
          color: this.payload.primary.formulaire_title_color || null
        },
        description: this.payload.primary.formulaire_description || [],
        cta: {
          text: this.payload.primary.formulaire_cta_text || null
        },
        mention: this.payload.primary.formulaire_mention || null
      };
    },

    submitStatusMessage() {
      return this.submitStatus === 'error' ? this.$t('submitError') : this.$t('submitConfirm');
    }

  }),
  methods: {
    createFormData(form) {
      var formData = [];
      formData['pro_contact[first_name]'] = form.name.model || null;
      formData['pro_contact[company]'] = form.company.model || null;
      formData['pro_contact[email]'] = form.email.model || null;
      formData['pro_contact[zipcode]'] = form.zipCode.model || null;
      formData['pro_contact[type_client]'] = form.activity.model || null;
      formData['pro_contact[coun_id]'] = form.country.model || null;
      formData['pro_contact[request_type]'] = form.requestType.model || null;
      formData['pro_contact[commentaire]'] = form.request.model || null;
      return formData;
    },

    validateField(key) {
      this.form[key].error = !this.form[key].model && this.form[key].required ? this.$t('mandatoryFields') : null;
      if (this.form[key].type === FieldType.Email && !this.form[key].error) this.form[key].error = !validateEmail(this.form[key].model) ? this.$t('errorEmail') : null;
    },

    validateForm() {
      Object.entries(this.form).forEach((_ref) => {
        var [key] = _ref;
        return this.validateField(key);
      });
      return Object.keys(this.form).every(field => this.form[field].error == null);
    },

    validateCaptcha() {
      // TO DO : ADD recaptcha
      return true;
    },

    submitForm() {
      var _this = this;

      return _asyncToGenerator(function* () {
        if (_this.validateForm() && _this.validateCaptcha()) {
          _this.showLoader = true;

          try {
            var result = yield submitProContactForm(_this.$store, _this.createFormData(_this.form));

            if (result && result.data && !result.data.success) {
              _this.submitStatus = 'error';
              return;
            }

            _this.submitStatus = 'confirm';

            _this.$root.$emit('notification', {
              message: _this.$t('submitConfirm'),
              type: 'success'
            });

            _this.$root.$emit('generic-tracking', null, {
              data: {
                event_category: 'Professionnels',
                event_action: 'Accueil',
                event_label: 'Formulaire_valide'
              }
            });

            _this.$router.push({
              name: 'market-language-editorial',
              params: {
                market: _this.locale.market,
                language: _this.locale.language,
                alias: 'business',
                slug: 'accueil'
              }
            });
          } catch (e) {
            _this.$logger.error("error ".concat(e));

            _this.$root.$emit('notification', {
              message: _this.$t('submitError'),
              type: 'error'
            });
          } finally {
            _this.showLoader = false;
          }
        }
      })();
    }

  }
};